export default __webpack_public_path__ + "img/bzNuUgJz.ed36fd36.svg";